/**
 * @generated SignedSource<<2dbc063e2ea96142397d19bbed7fb26b>>
 * @relayHash d08e7759f2105b4b0dd411a83b8f04e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c26dea658e6d1790bd00ec8dbe5685a31bfec47519454a0d9e2a8bcecaa84511

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AggTeamDirectoryPageQuery$variables = {
  scopeId: string;
};
export type AggTeamDirectoryPageQuery$data = {
  readonly team: {
    readonly " $fragmentSpreads": FragmentRefs<"teamCustomFieldResolverFields">;
  } | null;
};
export type AggTeamDirectoryPageQuery = {
  response: AggTeamDirectoryPageQuery$data;
  variables: AggTeamDirectoryPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scopeId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "scopeId",
        "variableName": "scopeId"
      }
    ],
    "concreteType": "TeamCustomFieldInfo",
    "kind": "LinkedField",
    "name": "customFieldsWithinScope",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "type"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AggTeamDirectoryPageQuery",
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "teamCustomFieldResolverFields",
            "selections": (v1/*: any*/),
            "argumentDefinitions": [
              {
                "kind": "RootArgument",
                "name": "scopeId"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AggTeamDirectoryPageQuery",
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": (v1/*: any*/)
      }
    ]
  },
  "params": {
    "id": "c26dea658e6d1790bd00ec8dbe5685a31bfec47519454a0d9e2a8bcecaa84511",
    "metadata": {},
    "name": "AggTeamDirectoryPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3e597f6751f226daf72e4a042f30490a";

export default node;
